module.exports = __webpack_public_path__ + "static/img/2.48e40f39.png";